export default __webpack_public_path__ + "static/img-success-story-tendo-5a0ba97a6fc51e534c888a92f734ef1c.png";